// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CustomFieldCollectionOutput,
    CustomFieldCollectionOutputFromJSON,
    CustomFieldCollectionOutputToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestPlanMinified
 */
export interface TestPlanMinified {
    /**
     * 
     * @type {number}
     * @memberof TestPlanMinified
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TestPlanMinified
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof TestPlanMinified
     */
    priority: TestPlanMinifiedPriorityEnum;
    /**
     * 0 = Draft; 1 = Ready to execute; 2 = Finish; 3 = Finished (with failures);
     * @type {number}
     * @memberof TestPlanMinified
     */
    status: TestPlanMinifiedStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof TestPlanMinified
     */
    testPlanFolder?: number;
    /**
     * 
     * @type {string}
     * @memberof TestPlanMinified
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TestPlanMinified
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TestPlanMinified
     */
    createdAt?: string;
    /**
     * Array of custom fields
     * @type {Array<CustomFieldCollectionOutput>}
     * @memberof TestPlanMinified
     */
    customFields?: Array<CustomFieldCollectionOutput>;
    /**
     * 
     * @type {number}
     * @memberof TestPlanMinified
     */
    isPublic?: number;
}

export function TestPlanMinifiedFromJSON(json: any): TestPlanMinified {
    return {
        'id': json['id'],
        'title': json['title'],
        'priority': json['priority'],
        'status': json['status'],
        'testPlanFolder': !exists(json, 'test_plan_folder') ? undefined : json['test_plan_folder'],
        'startDate': !exists(json, 'start_date') ? undefined : json['start_date'],
        'endDate': !exists(json, 'end_date') ? undefined : json['end_date'],
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
        'customFields': !exists(json, 'custom_fields') ? undefined : (json['custom_fields'] as Array<any>).map(CustomFieldCollectionOutputFromJSON),
        'isPublic': !exists(json, 'is_public') ? undefined : json['is_public'],
    };
}

export function TestPlanMinifiedToJSON(value?: TestPlanMinified): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'title': value.title,
        'priority': value.priority,
        'status': value.status,
        'test_plan_folder': value.testPlanFolder,
        'start_date': value.startDate,
        'end_date': value.endDate,
        'created_at': value.createdAt,
        'custom_fields': value.customFields === undefined ? undefined : (value.customFields as Array<any>).map(CustomFieldCollectionOutputToJSON),
        'is_public': value.isPublic,
    };
}

/**
* @export
* @enum {string}
*/
export enum TestPlanMinifiedPriorityEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}
/**
* @export
* @enum {string}
*/
export enum TestPlanMinifiedStatusEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}


